import "@shoelace-style/shoelace/dist/components/card/card.js";
import "@shoelace-style/shoelace/dist/components/avatar/avatar.js";

import { css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { Style } from "../Styles";
import { BaseElement } from "../BaseElement";
import { IJournal } from "../../backend/cloud/JournalTable";
7;
import { formatDateTime } from "../../Format";
import { LightTheme } from "../ThemeLight";

import "./JournalEntry";
import "../ProfileBadge/ProfileBadge";

@customElement("ds-journal")
export class Journal extends BaseElement {
    static override styles = [
        Style,
        LightTheme,
        css`
            :host {
                color: black;
            }
            sl-card {
                width: 100%;
            }

            .container {
                width: 100%;
                height: 100%;
                overflow-y: auto;
            }

            .date-time {
                font-size: 0.8em;
                float: right;
            }
        `,
    ];

    @property({ type: Object }) journal?: IJournal;

    override render() {
        return html`<div class="container ds-box-shadow">
            <div>
                ${this.journal
                    ? html`
                          <sl-card class="card-header">
                              <div slot="header">
                                  <ds-profile-badge
                                      .user=${this.journal.contributor ??
                                      this.journal.owner ??
                                      undefined}
                                      .detailText=${formatDateTime(this.journal.addedAt)}
                                  ></ds-profile-badge>
                              </div>
                              <div class="header">
                                  <ds-journal-entry
                                      .entry=${this.journal?.modification}
                                  ></ds-journal-entry>
                              </div>
                          </sl-card>
                          <br />
                      `
                    : html``}
            </div>
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-journal": Journal;
    }
}
